export default __webpack_public_path__ + "static/mortgage-award-2020-6d7085bbb0dfd64816fd7658466b6d13.png";